if(document.querySelector('.bmenu')){
	document.querySelector('.bmenu__toggle').addEventListener('click', () => {	
		document.querySelector('.bmenu').classList.toggle('_open')
	})
	
   document.addEventListener('click', (event) => {
        if (!document.querySelector('.bmenu').contains(event.target)) {
            document.querySelector('.bmenu').classList.remove('_open')
        }
    });
}